// extracted by mini-css-extract-plugin
export default {"wrapper":"settings_wrapper__gh-wx","full":"settings_full__KJIui","page-info":"settings_page-info__XCR20"};